import io from 'socket.io-client'
export default {
  state: {
    chatSocket: null,
    chatUser: null,
    chatList: [],
    chatOnlineList: [],
    unreadCount: 0,
    isChatConnected: false,
    isChatAuth: false,
    chatMessage: null,
    chatMessages: []
  },
  mutations: {
    setSocket (state, payload) {
      state.chatSocket = payload
    },
    setChatUser (state, payload) {
      state.chatUser = payload
    },
    setChatList (state, payload) {
      for (let i = 0; i < payload.length; i++) {
        payload[i].isOnline = false
        for (let k = 0; k < state.chatOnlineList.length; k++) {
          if (payload[i].id === state.chatOnlineList[k].id) {
            payload[i].isOnline = true
            break
          }
        }
      }
      state.chatList = payload
    },
    setChatOnlineList (state, payload) {
      state.chatOnlineList = payload
      this.commit('setChatList', state.chatList)
    },
    addChatListItems (state, payload) {
      let chatList = state.chatList.concat(payload)
      this.commit('setChatList', chatList)
    },
    setUnreadCount (state, payload) {
      state.unreadCount = payload
    },
    setIsChatConnected (state, payload) {
      state.isChatConnected = payload
    },
    setIsChatAuth (state, payload) {
      state.isChatAuth = payload
    },
    setChatMessage (state, payload) {
      for (let i = 0; i < state.chatList.length; i++) {
        if (payload.message.chatId === state.chatList[i].id) {
          state.chatList[i].lastMessage = payload.message
        }
      }
      for (let i = 0; i < state.chatOnlineList.length; i++) {
        if (payload.message.chatId === state.chatOnlineList[i].id) {
          state.chatOnlineList[i].lastMessage = payload.message
        }
      }
      state.chatMessage = payload
    },
    setChatMessages (state, payload) {
      state.chatMessages = payload
    }
  },
  actions: {
    async createChatSocket ({commit, dispatch, getters}) {
      let socket = io.connect(this.getters.chatServer, {
        reconnection: true,
        reconnectionDelay: 10000,
        reconnectionDelayMax: 10000,
        reconnectionAttempts: Infinity
      })

      commit('setSocket', socket)

      socket.on('connect', () => {
        commit('setIsChatConnected', true)
        socket.emit('auth', {source: 'admin', token: getters.accessToken})
      })

      socket.on('disconnect', () => {
        commit('setIsChatConnected', false)
        commit('setChatList', [])
        commit('setChatOnlineList', [])
      })

      socket.on('auth', data => {
        if (data.success) {
          commit('setIsChatAuth', true)
          commit('setChatUser', data.user)
          dispatch('getChats', {limit: 20})
          dispatch('getOnlineChats')
          dispatch('getUnreadedCount', {})
        } else {
          commit('setIsChatAuth', false)
        }
      })

      socket.on('onOnlineChats', data => {
        if (data.length) {
          commit('setChatOnlineList', data)
        } else {
          commit('setChatOnlineList', [])
        }
      })

      socket.on('onChats', data => {
        data.reverse()
        commit('addChatListItems', data)
      })

      socket.on('onMessage', data => {
        commit('setChatMessage', data)
        commit('setUnreadCount', data.totalUnread)
      })

      socket.on('onMessages', data => {
        commit('setChatMessages', data)
      })

      socket.on('onUnreadCount', data => {
        commit('setUnreadCount', data.totalUnread)
      })
    },
    async getOnlineChats ({commit, dispatch, getters}) {
      getters.chatSocket.emit('getOnlineChats')
    },
    async getChats ({commit, dispatch, getters}, {limit, lastId}) {
      if (limit) {
        limit = 20
      }
      if (!lastId) {
        getters.chatSocket.emit('getChats', {limit: limit})
      } else {
        getters.chatSocket.emit('getChats', {limit: limit, lastId: lastId})
      }
    },
    async sendMessage ({commit, dispatch, getters}, {chatId, message, attachmentFile = null}) {
      getters.chatSocket.emit('sendMessage', {chatId: chatId, user: getters.chatUser, message: message, attachmentFile: attachmentFile})
    },
    async onReadMessage ({commit, dispatch, getters}, {messageId}) {
      getters.chatSocket.emit('onReadMessage', {messageId: messageId})
    },
    async getMessages ({commit, dispatch, getters}, {chatId, lastMessageId, limit}) {
      if (!limit) {
        limit = 20
      }
      if (lastMessageId) {
        getters.chatSocket.emit('getMessages', {chatId: chatId, lastMessageId: lastMessageId, limit: limit})
      } else {
        getters.chatSocket.emit('getMessages', {chatId: chatId, limit: limit})
      }
    },
    async getUnreadedCount ({commit, dispatch, getters}, {chatId}) {
      if (chatId) {
        getters.chatSocket.emit('getUnreadCount', {chatId: chatId})
      } else {
        getters.chatSocket.emit('getUnreadCount')
      }
    },
    async chatUploadFiles ({commit, dispatch}, {files}) {
      let formData = new FormData()
      for (let key in files) {
        formData.append('file' + key, files[key])
      }
      let post = {
        data: formData
      }
      post.baseUrl = this.getters.chatFileServer
      post.url = '/upload?source=admin&token=' + this.getters.accessToken
      post.json = false
      let returnData = null
      await dispatch('apiPost', post)
        .then((data) => {
          returnData = data.data
        })
        .catch((error) => {
          throw error
        })
      return returnData
    },
    async closeChatSocket ({getters}) {
      getters.chatSocket.close()
    }
  },
  getters: {
    chatSocket (state) {
      return state.chatSocket
    },
    chatUser (state) {
      return state.chatUser
    },
    chatList (state) {
      return state.chatList
    },
    chatOnlineList (state) {
      return state.chatOnlineList
    },
    unreadCount (state) {
      return state.unreadCount
    },
    isChatConnected (state) {
      return state.isChatConnected
    },
    isChatAuth (state) {
      return state.isChatAuth
    },
    chatMessage (state) {
      return state.chatMessage
    },
    chatMessages (state) {
      return state.chatMessages
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/chat.js